import { render, staticRenderFns } from "./TramosRutasDetalle.vue?vue&type=template&id=47601006"
import script from "./TramosRutasDetalle.vue?vue&type=script&lang=js"
export * from "./TramosRutasDetalle.vue?vue&type=script&lang=js"
import style0 from "./TramosRutasDetalle.vue?vue&type=style&index=0&id=47601006&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports